module.exports = __webpack_public_path__ + "img/arrow-up-long.0e49dd1c.svg";